import Grid from "@mui/material/Grid/Grid"

import { backgroundURL } from "./experiments"

export function SplashGrid({ children }: Transclusion) {
  return (
    <Grid container sx={{ height: "100%" }}>
      <SplashColumn>
        <div />
      </SplashColumn>
      <MobileColumn>{children}</MobileColumn>
    </Grid>
  )
}

type Transclusion = {
  children: JSX.Element | JSX.Element[]
}

const SplashColumn = (props: Transclusion) => (
  <Grid
    item
    xs={false}
    md={6}
    lg={7}
    sx={{
      background: `url(${backgroundURL}) no-repeat, linear-gradient(to bottom, #666, #ddd)`,
      backgroundSize: "cover, auto",
      backgroundPosition: "center, center",
      backgroundBlendMode: "multiply",
      height: "100%",
      overflowY: "auto",
      padding: { md: 3, lg: 2 },
    }}
  >
    {props.children}
  </Grid>
)

function MobileColumn(props: Transclusion) {
  return (
    <Grid
      item
      sx={{
        userSelect: "none",
        height: "100%",
        overflowY: "auto",
        position: "relative",
      }}
      xs={12}
      md={6}
      lg={5}
    >
      {props.children}
    </Grid>
  )
}
